import { CompetitionsForms } from '@johnlewispartnership/wtr-content-component-library';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';

import competitions from 'services/competitions';
import { type CompetitionEntryValues } from 'services/competitions/types';
import { usePreloadedData } from 'renderer/context/preloadedDataContext';

import { getRecaptchaToken, RECAPTCHA_SRC, useGoogleReCaptcha } from './get-recaptcha-token';

type CompetitionsFormsWrapperProps = {
  competitionEndDate: string;
  competitionId: string;
  competitionName: string;
  competitionQuestion: string;
  competitionStatus: string;
  competitionType: string;
  breakpointClasses: string[];
  optIns: string[];
};

const CompetitionsFormsWrapper = (props: CompetitionsFormsWrapperProps) => {
  const { state } = useAuthentication();
  const { user } = usePreloadedData();

  const onFormSubmit = async (
    competitionEntryValues: CompetitionEntryValues,
    competitionsType: string,
    competitionId: string,
  ) => {
    const { optIns, purchaseType, onlineOrderNumber, receiptNumber, termsAndConditions, ...rest } =
      competitionEntryValues;

    const normalisedOptIns = optIns?.filter(Boolean).map(optIn => ({
      optInName: optIn,
    }));

    const token = await getRecaptchaToken();

    return competitions.submitCompetitionData(competitionId, competitionsType, {
      optIns: normalisedOptIns,
      orderId: purchaseType && purchaseType === 'Online' ? onlineOrderNumber : receiptNumber,
      purchaseType,
      captchaKey: token,
      termsAndConditions: termsAndConditions === 'consent',
      ...rest,
    });
  };

  const formProps = {
    competitionsSingleClickEntry: true,
    userIsLoggedIn: state.isLoggedIn,
    membershipCardNumber: user?.membershipNumber,
    emailAddress: user?.email,
    contactAddress: {
      addressee: {
        title: user?.title,
        firstName: user?.firstName,
        lastName: user?.lastName,
        contactNumber: user?.phone,
      },
    },

    onFormSubmit,
    useGoogleReCaptcha,
    ...props,
  };

  return (
    <>
      <script async data-testid="recaptcha" src={RECAPTCHA_SRC}></script>
      {/* @ts-expect-error TODO: WPIP-75318 - Fix types in the CCL  */}
      <CompetitionsForms {...formProps} />
    </>
  );
};

export default CompetitionsFormsWrapper;
